define('controllers/emailcampaignanalytics',['require','johngrid','services/tabmanager','jqBarGraph'],function(require) {
	var CreateJohnGrid = require('johngrid');
	var CreateTabManager = require('services/tabmanager');
	require('jqBarGraph');
	return function() {
		var tabManager = CreateTabManager($("#AnalyticTabs a"), [ { Href: "#weekAnalysisGraphs", Func: RefreshWeekGraphs },
                                                                      { Href: "#clickGridContainer", Func: RefreshClicks },
                                                                      { Href: "#popclicksAndDrill", Func: RefreshPeople, Unload: UnloadPeople },
                                                                      { Href: "#goalsTab", Func: RefreshGoals, Unload: UnloadGoals },
                                                                      { Href: "#emailTemplate", Func: RefreshTemplate, Unload: UnloadTemplate }]);

            tabManager.init();

            var grid = CreateJohnGrid(),
                gridURL = "CampaignAnalyticsAJAX.aspx",
                table = $('#tblCampaigns'),
                columns = [{ DataField: "Name" }, { DataField: "CreateDate"}],
                rollUpGrid = CreateJohnGrid(),
                rollUpColumns = [{ DataField: "EmailsReceived", HeaderText: "Times Received Campaign", DataType: "int" },
                                 { DataField: "Email" },
                                 { DataField: "OpenCount", HeaderText: "Opens", DataType: "int" },
                                 { DataField: "ClickCount", HeaderText: "Clicks", DataType: "int" }
                                ],
                personEventsGrid = CreateJohnGrid(),
                personEventsColumns = [{ DataField: "Event" }, { DataField: "When"}],
                txtSearch = $("#txtSearch"),
                goalsGrid = CreateJohnGrid(),
                goalsColumns = [{ DataField: "Status" }, { DataField: "Count", DataType: "int"}],
                btnRefresh = $("#btnRefresh");

            grid.sorting.allowSorting = true;
            grid.dsPostValues.sortClause = "CreateDate DESC";
            grid.selectHelpers.init($("#CampaignDetails"));
            grid.selectHelpers.onSelect = function (item) {
                rollUpGrid.utilities.cancelClick();

                //determine which tab to load...
                tabManager.Unload();
                var tabShowing = $("#AnalyticTabs li.active a").attr("href");
                tabManager.LoadTab(tabShowing);

                $("#txtSearchPeople").val("");
            };

            grid.onDataBinding = function () {
                grid.dsPostValues.search = txtSearch.val();
            };
            grid.init(table, columns, gridURL);
            $(".johnGridHeader", grid.$table).prepend($("#header"));
            grid.databind();
            txtSearch.on("change", function () { grid.databind(); });

            var personEventsDetail = $("#personEventsDetail");
	        rollUpGrid.pkColumnName = 'Email';
            rollUpGrid.selectHelpers.init(personEventsDetail);
            $(".btnCancel", personEventsDetail).val("Back To Rollup");

            rollUpGrid.selectHelpers.selectClick_Initial = rollUpGrid.selectHelpers.selectClick;
            rollUpGrid.selectHelpers.selectClick = function (e) {
                rollUpGrid.selectHelpers.getSinglePostValues.campaignIdsCSV = grid.utilities.selectedItem.PrimaryKey;
                rollUpGrid.selectHelpers.getSinglePostValues.Email = rollUpGrid.utilities.getItemForRowClick($(this)).Email;
                rollUpGrid.selectHelpers.selectClick_Initial.call(this, e);
            };
            rollUpGrid.selectHelpers.onSelect = function (item) {
                personEventsGrid.databind(item.events);
            };

            rollUpGrid.sorting.allowSorting = true;
            rollUpGrid.sorting.sortClientSide = true;
            rollUpGrid.showTopRow = false;
            rollUpGrid.init($("#rollUpGrid"), rollUpColumns, "rollUpGridAJAX.aspx");

            personEventsGrid.init($("#personEvents"), personEventsColumns);

            goalsGrid.dsPostValues.sortClause = "Status";
            goalsGrid.sorting.allowSorting = true;
            goalsGrid.sorting.sortClientSide = true;
            goalsGrid.showTopRow = false;
            goalsGrid.init($("#goalsGrid"), goalsColumns, "");

            function loadBasicAnalytics(totalRefresh) {
                btnRefresh.prop('disabled', true);
                grid.selectHelpers.getSingle(function () { //will need cleaner way to essentially call selectClick to re-get the data, or we will need to manually call onselect, too
                    btnRefresh.prop('disabled', false);
                    if (totalRefresh) {
                        var item = grid.utilities.selectedItem;
                        grid.selectHelpers.onSelect(item);
                    }
                });
            }

            //when switching tabs load top, if the tab hasn't already been loaded.
            tabManager.$tabAnchors.off("click").on("click", function (e) {
                e.preventDefault();
                var $this = $(this),
                    Href = $this.attr("href"),
                    tabLoaded = $.grep(tabManager.AnchorHrefsAndLoadFuncs, function (item, index) { return item.Href == Href && item.Loaded == true; }).length > 0;

                $this.tab('show');
                tabManager.LoadTab(Href);

                if (!tabLoaded) {
                    loadBasicAnalytics(false);
                }
            });

            btnRefresh.on("click", function () {
                loadBasicAnalytics(true);
            });

            function createGraph(elementId, $parent, Title, Data, type, legends, width, maxValueOverride) {
                $parent.append("<div id='" + elementId + "'></div>");
                var graph = $('#' + elementId);

                //now build the graph with fresh element
                if (Data.length > 0) {
                    graph.jqBarGraph({
                        data: Data, // array of data for your graph
                        title: Title, // title of your graph, accept HTML
                        barSpace: 10, // this is default space between bars in pixels
                        width: width, // default width of your graph
                        height: 200, //default height of your graph
                        color: '#08C', // if you don't send colors for your data this will be default bars color
                        colors: ['#053E80', '#08C'], // array of colors that will be used for your bars and legends
                        lbl: '', // if there is no label in your array
                        sort: false, // sort your data before displaying graph, you can sort as 'asc' or 'desc'
                        position: 'bottom', // position of your bars, can be 'bottom' or 'top'. 'top' doesn't work for multi type
                        prefix: '', // text that will be shown before every label
                        postfix: '', // text that will be shown after every label
                        animate: true, // if you don't need animated appearance change to false
                        speed: 2, // speed of animation in seconds
                        legendWidth: 100, // width of your legend box
                        legend: legends.length > 0, // if you want legend change to true
                        legends: legends, // array for legend. for simple graph type legend will be extracted from labels if you don't set this
                        type: type, // for multi array data default graph type is stacked, you can change to 'multi' for multi bar type
                        showValues: true, // you can use this for multi and stacked type and it will show values of every bar part
                        showValuesColor: '#fff', // color of font for values
                        maxValueOverride: maxValueOverride
                    });
                    graph.show();
                } else {
                    graph.hide();
                }
            }

            //tab data functions
            function RefreshWeekGraphs() {
                var weekAnalysisGraphs = $("#CampaignDetails .weekAnalysisGraphs");

                LoadAnalyticData("GetWeekAnalysis", weekAnalysisGraphs, function (campaignFirstWeeks) {
                    for (var i = campaignFirstWeeks.length - 1; i >= 0; i--) { //ordered by sentDate, but inserted backward, so loop backward
                        //add graph...
                        var graphId = "weekGraph_" + i,
                            outerData = campaignFirstWeeks[i],
                            graphTitle = "<h5 style='margin-bottom:30px;'>Campaign, sent on " + outerData.SentDate + "</h5>",
                            graphData = outerData.plotData;

                        createGraph(graphId, weekAnalysisGraphs, graphTitle, graphData, 'multi', ['Opens', 'Clicks'], 900);
                        var graphContainer = $("#" + graphId).parent();
                        graphContainer.addClass("well");
                        $("<br class='clear' />").insertAfter(graphContainer);
                    }
                });
            }

            function RefreshClicks() {
                var clickGridContainer = $("#CampaignDetails .clickGridContainer");

                LoadAnalyticData("GetClicks", clickGridContainer, function (clickGraphData) {

                    //createGraph("clickGraph", clickGridContainer, "<h5 style='margin-bottom:30px;'>Clicks Stats</h5>", clickGraphData, false, false, 900);

                    //split clicks up into graphs of 5 max.
                    var currentGraphData = [],
                        clickDataLength = clickGraphData.length,
                        clicksPerGraph = 5,
                        maxValueOverride = getMaxValue(clickGraphData);

                    for (var i = 0; i < clickDataLength; i++) {
                        currentGraphData.push(clickGraphData[i]);

                        var lastOne = (i + 1) == clickDataLength,
                            currentDataLength = currentGraphData.length;

                        if (lastOne || currentDataLength == clicksPerGraph) { //if we're at the end OR if we've got a new chunk of 5
                            if (lastOne) {
                                //fill in with empties so that click bars are the same width
                                var emptiesNeeded = clicksPerGraph - currentDataLength;
                                for (var j = 0; j < emptiesNeeded; j++) {
                                    currentGraphData.push(["", ""]);
                                }
                            }

                            //create graph
                            var graphId = "clickGraph_{0}".format(i);
                            createGraph(graphId, clickGridContainer, "<br /><br />", currentGraphData, false, false, 900, maxValueOverride);
                            currentGraphData = [];
                        }
                    }
                });
            }

            function getMaxValue(ar){
                maxvalue = 0;
                for(var val in ar){
                    value = ar[val][0];
                    if(value instanceof Array) value = sum(value);	
                    if (parseFloat(value) > parseFloat(maxvalue)) maxvalue=value;
                }	
                return maxvalue;	
            }

            var btnSearchPeople = $("#btnSearchPeople"),
                txtSearchPeople = $("#txtSearchPeople");
            btnSearchPeople.on("click", RefreshPeople);
            function RefreshPeople() {
                btnSearchPeople.prop('disabled', true);
                LoadAnalyticData("GetPeople", $("#popclicksAndDrill"), function (openingsAndClicksByPerson) {
                    rollUpGrid.databind(openingsAndClicksByPerson);
                    btnSearchPeople.prop('disabled', false);
                }, txtSearchPeople.val());
            }
            function UnloadPeople() {
                rollUpGrid.setGrid("");
            }

            function RefreshGoals() {
                //only load on button push, since this is slow as piss, currently
            }
            $("#btnLoadGoals").on("click", function () {
                LoadAnalyticData("GetGoals", $("#goalsTab"), function (peopleStatus) {
                    goalsGrid.databind(peopleStatus);
                });
            });
            function UnloadGoals() {
                goalsGrid.setGrid("");
            }

            function RefreshTemplate() {
                var emailTemplate = $("#emailTemplate");

                LoadAnalyticData("getTemplate", emailTemplate, function (template) {
                    $("#emailTemplateFrame").contents().find('html').html(template);
                });
            }
            function UnloadTemplate() {
                $("#emailTemplateFrame").contents().find('html').html("");
            }

            function LoadAnalyticData(method, $tabPane, callBack, SearchTerm) {
                var $loading = $(grid.htmlHelpers.loadingImg(true));
                $tabPane.prepend($loading);
                $.post(gridURL, { method: method, PrimaryKey: grid.utilities.selectedItem.PrimaryKey, SearchTerm: SearchTerm }, function (response) {
                    Utilities.handleAJAXResponse(response, function (obj) {
                        callBack.call(null, obj);
                    },
                    function (error) {
                        grid.utilities.setError(error);
                    });
                }).complete(function () {
                    $loading.remove();
                });
            }

            Utilities.setDefaultButton(txtSearchPeople, btnSearchPeople);
	};
});
